import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import Promoter from './Promoter';
import { texts } from 'utils/languages/fr';
import { ListContainer } from 'components';
import PromotersTable from './PromotersTable';

const Promoters = () => {
    const { path } = useRouteMatch();

    return (
        <ListContainer>
            <Switch>
                <Route path={path} exact component={PromotersTable} />
                <Route path={`${path}/create`} title={texts.PROMOTER_CREATE} component={Promoter} />
                <Route path={`${path}/edit/:id`} title={texts.PROMOTER_EDIT} component={Promoter} />
            </Switch>
        </ListContainer>
    );
};

export default Promoters;
